'use strict';

var React = require('react');

var SvgGiftCardMajor = function SvgGiftCardMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4.5c0-.737.69-1.5 1.77-1.5 1.048 0 2.23.87 2.23 2.333v.667h-.846c-.805 0-1.656-.011-2.306-.25-.302-.112-.498-.253-.621-.413-.115-.15-.227-.397-.227-.837zm6.846 1.5h-.846v-.667c0-1.463 1.181-2.333 2.23-2.333 1.08 0 1.77.763 1.77 1.5 0 .44-.112.686-.227.837-.123.16-.319.3-.621.412-.65.24-1.5.251-2.306.251zm5.154-1.5c0 .558-.103 1.06-.306 1.5h1.806a1.5 1.5 0 0 1 1.5 1.5v2.5h-20v-2.5a1.5 1.5 0 0 1 1.5-1.5h1.806a3.547 3.547 0 0 1-.306-1.5c0-2.03 1.783-3.5 3.77-3.5 1.165 0 2.398.546 3.23 1.529.832-.983 2.065-1.529 3.23-1.529 1.988 0 3.77 1.47 3.77 3.5zm-8 15.5v-8h-8v6.5c0 .83.67 1.5 1.5 1.5h6.5zm2 0v-8h8v6.5c0 .83-.67 1.5-1.5 1.5h-6.5z"
  }));
};

exports.SvgGiftCardMajor = SvgGiftCardMajor;
